/**Handle Numeric only input for SSN field*/
export const containsOnlyNumbers = (str: string) => {
  return /^[-0-9]*$/.test(str);
};
